export default function preferDefault(m) {
  return (m && m.default) || m;
}
